module.exports = __webpack_public_path__ + "static/media/[面条]@2x.0a5c7bd3.png";